<template>
  <b-container fluid class="py-3">
    <b-row class="mb-2">
      <b-col>
        <img src="@/assets/logo.png" fluid alt="ロゴ" class="w-100" />
      </b-col>
    </b-row>
    <b-row v-if="$store.getters.term">
      <b-col class="text-center h3">{{ $store.getters.term.terminalName }}</b-col>
    </b-row>
    <b-row>
      <b-col class="text-center">{{ version }}</b-col>
    </b-row>
    <b-row v-if="visibleBackButton" class="mt-3">
      <b-col>
        <b-button block pill variant="primary" @click="onNavigateBack()">戻る</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: 'VersionInfo',
    data() {
      return {
        isTopPage: false,
        version: require('../../package.json').version
      };
    },
    mounted() {
      // 画面を初期化
      this.$emit('initView', { viewId: this.$options.name, useToolButtons: false });
    },
    computed: {
      visibleBackButton: function () {
        return !this.$store.getters.loggedIn;
      }
    },
    methods: {
      /**
       * 戻るナビゲート
       */
      onNavigateBack: function () {
        // ログイン画面へ
        this.$router.replace({ path: '/UserLogin' });
      }
    }
  };
</script>
